import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Jordskiftekrevd extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleJordskiftekrevd = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var jordskiftekrevd = this.props.jordskiftekrevd
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleJordskiftekrevd}>
                    <span className="title"><Moment local>{jordskiftekrevd.jordskifteKrevdFortDato}</Moment> {jordskiftekrevd.jordskifteReferanse}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('jordskiftereferanse')}</div>
                            <div className="value">{jordskiftekrevd.jordskifteReferanse}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('jordskiftekrevdfortdato')}</div>
                            <div className="value"><Moment local>{jordskiftekrevd.jordskifteKrevdFortDato}</Moment></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Jordskiftekrevd)